import { FormAlert, useForm, useFormAlert } from '@/libs/antd/form';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import rule from '@/libs/antd/rules';
import { SiteReportUnitAnalysis } from '@/libs/fleet-api/services/types';
import { Divider, Form, Input } from 'antd';
import { FC } from 'react';
import { useFRMSiteVisitReportPage } from './SiteReportPage';

export const useFRMSiteVisitReportUnitForm = () => {
	return useForm<SiteReportUnitAnalysis<'payload'>>();
};

type FRMSiteVisitReportUnitProps = {
	onSubmit: (values: SiteReportUnitAnalysis<'payload'>) => void;
};
const FRMSiteVisitReportUnit: FC<FRMSiteVisitReportUnitProps> = ({
	onSubmit,
}) => {
	const { query, siteReportUnitForm } = useFRMSiteVisitReportPage();
	const { siteReport, surveyInformation } = query.data?.data ?? {};
	const { form, fieldName } = siteReportUnitForm;
	const { alerts } = useFormAlert(form, null, false);

	return (
		<Form
			{...ANTD_DEFAULT_PROPS.FORM}
			form={form}
			labelCol={{
				span: 10,
			}}
			initialValues={
				{
					id: siteReport?.id,
					surveyId: surveyInformation!.id,
					additionalUnitInfo: siteReport?.additionalUnitInfo,
					operatingUnitVerification: siteReport?.operatingUnitVerification,
					unitNeedsVerification: siteReport?.unitNeedsVerification,
				} as SiteReportUnitAnalysis<'payload'>
			}
			onFinish={onSubmit}
		>
			<Form.Item
				name={fieldName('id')}
				noStyle
			/>
			<Form.Item
				name={fieldName('surveyId')}
				noStyle
			/>
			<Form.Item
				name={fieldName('unitNeedsVerification')}
				label="Verifikasi Kebutuhan Unit"
				labelCol={{
					span: 6,
				}}
				rules={[rule.required('Verifikasi Kebutuhan Unit wajib diisi')]}
			>
				<Input.TextArea rows={4} />
			</Form.Item>
			<Divider />
			<Form.Item
				name={fieldName('operatingUnitVerification')}
				label="Verifikasi Unit yang sedang Beroperasi"
				labelCol={{
					span: 6,
				}}
				rules={[
					rule.required('Verifikasi Unit yang sedang Beroperasi wajib diisi'),
				]}
			>
				<Input.TextArea rows={4} />
			</Form.Item>
			<Divider />
			<Form.Item
				name={fieldName('additionalUnitInfo')}
				label="Informasi Lainnya"
				labelCol={{
					span: 6,
				}}
				rules={[rule.required('Informasi Lainnya wajib diisi')]}
			>
				<Input.TextArea rows={4} />
			</Form.Item>
			<Divider />
			<FormAlert alerts={alerts} />
		</Form>
	);
};

export default FRMSiteVisitReportUnit;
